import { Component, Input } from '@angular/core';
import { CaseField } from '../../../domain/definition/case-field.model';

@Component({
  selector: 'ccd-label-field',
  template: require('./label-field.html')
})
export class LabelFieldComponent {
  @Input()
  caseField: CaseField;

  @Input()
  caseFields: CaseField[] = [];
}
